import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { DummySidebar } from "pages/sideBar";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";
import { defaultPathConfigRepository } from "../pathConfig/PathConfigRepository";
import {
  MenuConfigModel,
  SidebarMenuConfigModel,
} from "./model/SidebarMenuConfigModel";

export interface IConfigRepository {
  getSidebarMenu(
    role: boolean
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>>;
}

export interface IMenuService {
  name: string;
  path: string;
  componentName: string;
  icon: string;
  subMenu?: IMenuService[] | [];
  enable?: boolean;
}

export class SidebarMenuConfigRepository implements IConfigRepository {
  async getSidebarMenu(
    role: boolean
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>> {
    let menuConfig: MenuConfigModel[] = [];

    try {
      const res = await defaultPathConfigRepository?.configDetail(
        "b2c_cms_menu_items"
      );
      if (res) {
        const data = JSON.parse(res?.data?.data?.config as string);
        const admin = data?.admin;
        const user = data?.user;

        switch (role) {
          case true:
            menuConfig = this.mapMenuItems(admin);
            break;
          case false:
            menuConfig = this.mapMenuItems(user);
            break;
          default:
            return Promise.reject("Invalid role");
        }
      }
    } catch (error) {
      getMessage(strings.GlobalMessage.InvalidMenuConfig, 4, "error");

      switch (role) {
        case true:
          menuConfig = this.mapMenuItems(DummySidebar.admin);
          break;
        case false:
          menuConfig = this.mapMenuItems(DummySidebar.user);
          break;
        default:
          return Promise.reject("Invalid role");
      }

      console.error(error);
    }

    return Promise.resolve(
      new BaseApiResponseModel<SidebarMenuConfigModel>(
        { data: new SidebarMenuConfigModel(menuConfig) },
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      )
    );
  }

  private mapMenuItems(items: IMenuService[] = []): MenuConfigModel[] {
    return items
      .filter((item) => item.enable !== false)
      .map(
        (item) =>
          new MenuConfigModel(
            item.name,
            item.path,
            item.componentName,
            item.icon,
            this.mapMenuItems(item.subMenu) // recursive call for submenu
          )
      );
  }
}

export default new SidebarMenuConfigRepository();
